<template>
    <div>
        <p>The Key Person below will be your account administrator. This person will have access to your bid information and other sensitive data. Please be sure the key person is authorized to receive, review and edit your company information.</p>
        <div class="form-wrap" v-if="user.role == 'Field'">
            <p>Not Allowed to Edit Profile</p>
        </div>
        <div class="form-wrap" v-else>
            <form @submit.prevent="submit_form">
                <div class="row">
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Company <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="company" name="company" v-model="model.company">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Key Person Title <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="title" name="title" v-model="model.title">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>First Name <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="first_name" name="first_name" v-model="model.first_name">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Last Name <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="last_name" name="last_name" v-model="model.last_name">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Office Phone <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="phone" name="phone" v-model="model.phone">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Email <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="email" name="email" v-model="model.email">
                        <div v-for="(error, key) in errors.email" :key="key">
                            <div class="error-message alert alert-danger mt-1" v-if="key == 0">{{ error }}</div>
                        </div>
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Fax</label>
                        <input type="text" class="form-control" ref="fax" name="fax" v-model="model.fax">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Cell Phone</label>
                        <input type="text" class="form-control" ref="cellphone" name="cellphone" v-model="model.cellphone">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Street Address <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="address" name="address" v-model="model.address">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Country <span class="required-indicator">*</span></label>
                        <select class="form-control" ref="country" name="country" v-model="model.country">
                            <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>City <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="city" name="city" v-model="model.city">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>State/Province <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="state" name="state" v-model="model.state">
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label>Zip Code <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="zipcode" name="zip" v-model="model.zipcode">
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group" ref="other_names">
                            <label>Other Names</label>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 30%;">Name</th>
                                        <th style="width: 30%;">Email</th>
                                        <th style="width: 30%;">Phone</th>
                                        <th style="width: 10%;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, key) in model.other_names" :key="key">
                                        <td><input type="text" class="form-control" v-model="row.name" :required="key > 0"></td>
                                        <td><input type="email" class="form-control" v-model="row.email" :required="key > 0"></td>
                                        <td><masked-input mask="\+11 (111) 111-1111" v-model="row.phone" class="form-control" autocomplete="disabled" :required="key > 0"/></td>
                                        <td>
                                            <div class="row-btns">
                                                <button class="btn btnAddNameRow" type="button" @click="add_name_row"><span class="fa fa-plus"></span></button>
                                                <button class="btn btnRemoveNameRow" type="button" @click="remove_name_row(key)"><span class="fa fa-close"></span></button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row" id="change_password">
                    <div class="form-group col-md-12" v-if="!isSuccess">
                        <button class="btn" type="button" :disabled="isSubmitting" @click="submit">
                            <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                            <template v-else>Send Password Reset Link</template>
                        </button>
                    </div>
                    <div class="form-group col-md-12" v-else>
                        <p>
                            A password reset link was sent to <b>{{ email }}</b>. 
                            If you didn't receive any email 
                            <template v-if="isSubmitting"><b><span class="fa fa-spinner fa-pulse"></span></b></template>
                            <template v-else>
                                <a href="javascript:void(0);" @click="submit"><b>Click Here</b></a>
                            </template>
                            to try again.
                        </p>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="form-group col-md-12">
                        <label>Security Question</label>
                        <select class="form-control" ref="security_question" v-model="model.security_question">
                            <option value="">- Select security question -</option>
                            <option v-for="question in security_questions" :key="question.id" :value="question.id">{{ question.question }}</option>
                        </select>
                        <input type="text" class="form-control mt-1" placeholder="Your security answer" ref="security_answer" v-model="model.security_answer">
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-12">
                        <div class="button-group">
                            <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                <template v-else>Update</template>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import MaskedInput from 'vue-masked-input'

export default {
    components: { MaskedInput },
    data() {
        return {
            user: {},
            countries: window.countries,
            isSubmitting: false,
            isSuccess: false,
            email: false,
            errors: [],
            security_questions: [],
            model: {
                company: '',
                title: '',
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                fax: '',
                cellphone: '',
                address: '',
                country: '',
                city: '',
                state: '',
                zipcode: '',
                other_names: [],
                password: '',
                password_confirmation: '',
                security_question: '',
                security_answer: ''
            },
            password_validation: {
                char_length: false,
                lowercase: false,
                uppercase: false,
                digit: false,
                special_char: false
            }
        }
    },
    mounted() {
        this.get_profile()
        this.get_security_questions()
    },
    watch: {
        'model.other_names'(n) {
            if(!n) {
                this.model.other_names = [{ name: '', email: '', phone: '' }]
            }
        }
    },
    methods: {
        check_user() {
            let user = localStorage.getItem('user')
            if(user) {
                user = JSON.parse(user)
                this.model.id = user.id
                this.model.username = user.username
                this.password_reset_status = user.password_reset_status
                this.mandatory_reset_date = user.mandatory_reset_date
                this.user = user
            }
        },
        submit() {
            this.isSubmitting = true
            this.check_user()

            this.$http.post('/api/reset_password_token', this.model)
                .then((res) => {
                    this.isSubmitting = false
                    this.isSuccess = true
                    this.email = res.data.data.email
                })
                .catch(() => {
                    this.isSubmitting = false
                })
        },
        get_profile() {
            var user = localStorage.getItem('user');
            if ( !user ) this.$router.push('login');
            this.user = JSON.parse(user);

            this.$http.get('/api/user_profile')
                .then(response => {
                    this.model = response.data.data
                })
        },
        get_security_questions() {
            this.$http.get('/api/security_questions')
                .then(response => {
                    this.security_questions = response.data.data
                })
        },
        submit_form() {
            this.isSubmitting = true
            this.$http.put('/api/user_profile', this.model)
                .then(response => {
                    this.model = response.data.data
                    this.isSubmitting = false
                    this.reset_form()
                    this.validation_error(false)
                    alert('Saved!')
                })
                .catch(error => {
                    if(error.response.data.message == 'validation_error') {
                        this.validation_error(error.response.data.errors)
                        this.errors = error.response.data.errors
                    }
                    this.isSubmitting = false
                })
        },
        add_name_row() {
            this.model.other_names.push({ name: '', email: '', phone: '' });
        },
        remove_name_row(key) {
            this.model.other_names.splice(key, 1);
            if(this.model.other_names.length == 0) {
                this.model.other_names = [{ name: '', email: '', phone: '' }];
            }
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) { 
                el.classList.remove('hasError')
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                    }
                }
            }
        },
        validate_password() {
            if(this.model.password.length >= 8) {
                this.password_validation.char_length = true
            } else {
                this.password_validation.char_length = false
            }

            if((/[a-z]/.test(this.model.password))) {
                this.password_validation.lowercase = true
            } else {
                this.password_validation.lowercase = false
            }

            if((/[A-Z]/.test(this.model.password))) {
                this.password_validation.uppercase = true
            } else {
                this.password_validation.uppercase = false
            }

            if((/[0-9]/.test(this.model.password))) {
                this.password_validation.digit = true
            } else {
                this.password_validation.digit = false
            }

            if((/[~`!@#$%^&*()\-_+={}[\]|\\:;"'<>,.?/]/.test(this.model.password))) {
                this.password_validation.special_char = true
            } else {
                this.password_validation.special_char = false
            }
        },
        reset_form() {
            this.errors = []
            this.model.password = ''
            this.model.password_confirmation = ''
            this.password_validation = {
                char_length: false,
                lowercase: false,
                uppercase: false,
                digit: false,
                special_char: false
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.table {
    width: 100%;
    th, td {
        padding: 0.5em;
    }
}
.btnAddNameRow, .btnRemoveNameRow {
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 28px;
    padding: 0;
    float: right;
}
.btnAddNameRow {
    background-color: #459e45;
    color: #fff;
    &:hover {
        color: #000;
    }
}
.row-btns {
    width: 60px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.error-message{
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    margin-bottom: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
}
.validation {
    color: #404040;
    .fa-check-circle {
        color: #459e45;
    }
    .fa-circle {
        color: #e6e6e6;
    }
}
</style>